import { useMemo } from 'react'

import { useCopy } from 'hooks/helpers'

import { generateAddresses } from 'utils/crypto'
import { createModal, ModalName, CloseButton } from 'modal'

import { Button, EditorComponent, Icon } from 'components/ui'
import { Wrap } from './Style'

type Props = {
  id: string
  onCurrentClose: VoidFunction
}

const randomList = generateAddresses(5)

const exampleValue = randomList.reduce((acc, curr, index) => {
  const postfix = index === randomList.length - 1 ? '' : '\n'
  acc = acc + `${curr.addr},${curr.amount}${postfix}`
  return acc
}, '')

// TODO: add example CSV file for download
export function ExampleModal({ id, onCurrentClose }: Props) {
  const [isCopied, handleClick] = useCopy(exampleValue)
  const copyIcon = useMemo(() => (isCopied ? 'tick' : 'copy'), [isCopied])

  return (
    <Wrap>
      <EditorComponent id={id} value={exampleValue} readonly editorErrorList={null} />
      <Button fullSize size='large' onClick={handleClick}>
        Copy
        <Icon name={copyIcon} size='extraMedium' />
      </Button>

      <CloseButton onClick={onCurrentClose}>
        <Icon name='close' size='large' />
      </CloseButton>
    </Wrap>
  )
}

const newExampleModal = () =>
  createModal({
    title: '_example',
    align: 'center',
    name: ModalName.EXAMPLE_CSV,
    disableOverlayClose: false,
    // @ts-ignore
    container: <ExampleModal />,
  })

export { newExampleModal }
